export const normalizeInvoiceName = value => String(value || '').normalize('NFKC').toLowerCase().replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
const containsName = (text, name) => !!name && ` ${text} `.includes(` ${name} `);
const ocrNumber = value => {
  let text = String(value ?? '').replace(/[^\d.,]/g, '');
  if (!text) return NaN;
  if (text.includes(',') && text.includes('.')) text = text.replace(/\./g, '').replace(',', '.');
  else if (text.includes(',')) text = text.replace(',', '.');
  else if (/\.\d{3}$/.test(text)) text = text.replace(/\./g, '');
  return Number(text);
};

export function matchInvoiceLines(text, lines, supplierId, aliases = []) {
  const scoped = aliases.filter(alias => alias.supplier_id === supplierId && alias.usable);
  const snippets = String(text || '').split(/\r?\n/).map(value => value.trim()).filter(Boolean).map(value => {
    const normalized = normalizeInvoiceName(value);
    return { value, normalized, aliases: scoped.filter(alias => containsName(normalized, normalizeInvoiceName(alias.name))) };
  });
  return lines.map(line => {
    const aliasRows = snippets.filter(row => row.aliases.some(alias => alias.product_id === line.product_id));
    const nameRows = snippets.filter(row => !row.aliases.length && containsName(row.normalized, normalizeInvoiceName(line.name)));
    const rows = aliasRows.length ? aliasRows : nameRows;
    const row = rows[0];
    const ambiguous = rows.length > 1 || (!!row && new Set(row.aliases.map(alias => `${alias.product_id}:${alias.unit}:${alias.pieces}`)).size > 1);
    const alias = row?.aliases.find(item => item.product_id === line.product_id);
    const unitMismatch = !!alias && (alias.unit !== line.unit || Number(alias.pieces) !== Number(line.pieces));
    const matchedName = alias?.name || line.name;
    const index = row?.value.toLowerCase().indexOf(String(matchedName).toLowerCase()) ?? -1;
    // When OCR punctuation differs, do not guess which digits belong to a name/code.
    const values = index >= 0 ? row.value.slice(index + matchedName.length) : '';
    const numbers = (values.match(/\d[\d.,]*/g) || []).map(ocrNumber).filter(Number.isFinite);
    return { lineId: line.lineId, snippet: row?.value || '', aliasName: alias?.name || '', aliasUnit: alias?.unit,
      aliasPieces: alias?.pieces, ambiguous, unitMismatch,
      quantityFound: !ambiguous && !unitMismatch && numbers.some(value => Math.abs(value - Number(line.qty)) < 0.000001),
      priceFound: !ambiguous && !unitMismatch && numbers.some(value => Math.abs(value - Number(line.cost)) < 0.01) };
  });
}
